import { getMasterTable } from '@repo/catalogs-services'
import { defineSagaForService } from '@repo/core'
import { MASTER_TABLE_KEYS } from '@repo/shared-types'
import { masterTableActions } from '../../slices'

export const loadMasterTablesCatalogServiceConfig = defineSagaForService(
  MASTER_TABLE_KEYS.reduce(
    (acc, key) => {
      const actions = masterTableActions[key]
      return {
        ...acc,
        [actions.getRequest.type]: {
          apiClientDomain: 'catalogs' as const,
          service: getMasterTable,
          getError: (error) => error.response?.data || error.message,
          actionTypeResponse: actions.getResponse.type,
          actionTypeRequest: actions.getRequest.type,
          getParams: (_: any): any => ({ catalog: key }),
        },
      }
    },
    {} as ReturnType<typeof defineSagaForService>,
  ),
)
